var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"search"}},[_c('search-result-view',{attrs:{"data":_vm.searchResult,"title":'Search Result',"menu":_vm.categories,"term":_vm.term,"category":_vm.category,"subCategory":_vm.subCategory,"paging":_vm.paging},on:{"nextpage":_vm.loadMoreData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }